import { createSlice } from '@reduxjs/toolkit';

import type { PayloadAction } from '@reduxjs/toolkit';

interface ExperimentEligibilityState {
    deviceId?: string;
    ineligibilityReason: string | null;
    isEligibleForAssignment: boolean | null;
    userProperties: {
        accept?: string;
        acceptLanguage?: string;
        asn?: string;
        cfBotScore?: number;
        ipAddress?: string;
        ja4?: string;
        userAgent?: string;
    };
}

interface ExperimentEligibilityAction {
    experimentEligibility: ExperimentEligibilityState;
}

const initialState = {
    deviceId: undefined,
    ineligibilityReason: null,
    isEligibleForAssignment: null,
    userProperties: {},
} satisfies ExperimentEligibilityState as ExperimentEligibilityState;

const experimentEligibilitySlice = createSlice({
    initialState,
    name: 'experimentEligibility',
    reducers: {
        experimentEligibilityReceived(state, action: PayloadAction<ExperimentEligibilityAction>) {
            const { experimentEligibility } = action.payload;

            state.deviceId = experimentEligibility.deviceId;
            state.isEligibleForAssignment = experimentEligibility.isEligibleForAssignment;
            state.ineligibilityReason = experimentEligibility.ineligibilityReason;
            state.userProperties = experimentEligibility.userProperties;
        },
    },
    selectors: {
        selectExperimentEligibility: (state: ExperimentEligibilityState) => state,
    },
});

export type ExperimentEligibility =
    ReturnType<typeof experimentEligibilitySlice.selectors.selectExperimentEligibility>;

export const { actions, selectors } = experimentEligibilitySlice;
export const { experimentEligibilityReceived } = actions;
export default experimentEligibilitySlice.reducer;
